// Shared address + Google-directions helpers for maintenance jobs.
// Mirrors the mobile app's `src/utils/openInMaps.ts#buildJobAddress` so the
// web and mobile surfaces resolve a job's site address identically.

/**
 * Build a best-effort human address string from the address fields the
 * maintenance-job API returns. Returns null when there's nothing usable.
 * Priority: freehand location_address → building address (+postcode) →
 * building name + postcode → postcode → building name.
 */
export function buildJobAddress(job) {
  if (!job) return null;
  const emergency = (job.location_address || "").trim();
  if (emergency) return emergency;

  const addr = (job.building_address || "").trim();
  const pc = (job.building_postcode || "").trim();
  const name = (job.building_name || "").trim();

  if (addr) return pc && !addr.includes(pc) ? `${addr}, ${pc}` : addr;
  if (name && pc) return `${name}, ${pc}`;
  if (pc) return pc;
  if (name) return name;
  return null;
}

/** Google Maps directions URL for the given address (null if no address). */
export function directionsUrl(address) {
  const a = (address || "").trim();
  if (!a) return null;
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(a)}`;
}

/**
 * Build a directions-ready address from a building record
 * (name / address / postcode). So inspectors & engineers can get
 * directions to ANY building, not just maintenance jobs.
 */
export function buildBuildingAddress(b) {
  if (!b) return null;
  const addr = (b.address || "").trim();
  const pc = (b.postcode || "").trim();
  const name = (b.name || "").trim();
  if (addr) return pc && !addr.includes(pc) ? `${addr}, ${pc}` : addr;
  if (name && pc) return `${name}, ${pc}`;
  if (pc) return pc;
  if (name) return name;
  return null;
}
